import {Component, DestroyRef, inject, OnInit, signal} from "@angular/core"
import { takeUntilDestroyed } from "@angular/core/rxjs-interop"
import { RouterLink, RouterOutlet } from "@angular/router"
import { map } from "rxjs"

import { Avatar } from "primeng/avatar"
import { MessageModule } from "primeng/message"

import { LgkNetwork, NetworkState } from "@logick/browser/network"
import {ApiAuthService, ApiUserModel} from "@logick/core-api"
import {LgkNavMenuItem} from "@logick/ui/api"
import { LgkSideNav } from "@logick/ui/sidenav"

import { environment } from "@/environment"
import { PartnerApiService } from "@/features/admin/partners/services/partners-api.service"
import {LgkUser, UserRole} from "@/features/admin/users"
import { getMenuForRole } from "../../app.menu"


@Component({
  selector: "app-main-layout",
  imports: [LgkSideNav, RouterOutlet, RouterLink, Avatar, MessageModule],
  providers:[LgkNetwork],
  templateUrl: "./main-layout.html",
  styleUrl: "./main-layout.scss"
})
export class MainLayout implements OnInit {
  private destroyRef = inject(DestroyRef)
  private network = inject(LgkNetwork)
  private apiAuthService = inject(ApiAuthService)
  private partnerApiService = inject(PartnerApiService)

  showOfflineMessage = signal<boolean>(false)
  userInitials = signal<string>("")
  filteredMenu = signal<LgkNavMenuItem[]>([])

  version = environment.appVersion

  ngOnInit(): void {
    this.handleNetwork()
    this.handleLoggedUser()
  }

  private handleNetwork() {
    this.network.listenNetworkState()

    this.network.stateChange
      .pipe(
        takeUntilDestroyed(this.destroyRef),
        map((it:NetworkState) => it === NetworkState.ONLINE)
      )
      .subscribe((online) => { this.showOfflineMessage.set(!online) })

  }

  private handleLoggedUser() {
    this.apiAuthService.connectedUser().subscribe({
      next: (user: ApiUserModel) => {
        const lgkUser = new LgkUser(user)

        this.userInitials.set(lgkUser.initials())

        if (lgkUser.role === UserRole.PARTNER) {
          this.partnerApiService.getPartnerById(lgkUser.organizationId).subscribe({
            next: (partner) => {
              this.filteredMenu.set(getMenuForRole(lgkUser.role, partner.catalogScope))
            },
            error: () => {
              this.filteredMenu.set(getMenuForRole(lgkUser.role))
            }
          })
        } else {
          this.filteredMenu.set(getMenuForRole(lgkUser.role))
        }
      }
    })
  }
}
